import angular from "angular";
import HomeLandingPageComponent from "./home-landing.component";
import LandingPageModule from "../../../components/landing-page/landing-page.module";
import VtSharedModule from '../../../../vt-shared/vt-shared.module';

import HomeLandingMainSectorModule from "./home-landing-main/home-landing-main.module";
import HomeLandingBikeProfileSectorModule from "./home-landing-bike-profile/home-landing-bike-profile.module";
import HomeLandingBookingStepsSectorModule from "./home-landing-booking-steps/home-landing-booking-steps.module";
import HomeLandingBrandsSectorModule from "./home-landing-brands/home-landing-brands.module";
import HomeLandingMobileAppsSectorModule from "./home-landing-mobile-apps/home-landing-mobile-apps.module";
import HomeLandingServicesSectorModule from "./home-landing-services/home-landing-services.module";
import HomeLandingWorkAreaSectorModule from "./home-landing-work-area/home-landing-work-area.module";

import ServiceProvidersPublicApi from "../../../resources/service-providers/public-service-providers.resource";
import LocationsPublicApi from "../../../resources/locations/public-locations.resource";
import ServicesPublicApi from "../../../resources/services/public-services.resource";
import UsersPublicApi from "../../../resources/user/public-user.resource";

export default angular.module("vt-public-home-landing.module", [
    VtSharedModule.name,
    LandingPageModule.name,
    HomeLandingMainSectorModule.name,
    HomeLandingBikeProfileSectorModule.name,
    HomeLandingBookingStepsSectorModule.name,
    HomeLandingBrandsSectorModule.name,
    HomeLandingMobileAppsSectorModule.name,
    HomeLandingServicesSectorModule.name,
    HomeLandingWorkAreaSectorModule.name,
    ServiceProvidersPublicApi.name,
    ServicesPublicApi.name,
    LocationsPublicApi.name,
    UsersPublicApi.name
]).component("homeLandingPage", HomeLandingPageComponent);
